import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { isEmailValid } from "../helper";
import { Translation } from "react-i18next";

const SendInvoiceModal = ({ closeModal, ticketDataPdf }) => {
  const [emailToSend, setemailToSend] = useState("");
  const [emailError, setemailError] = useState("");
  const [isMailFormValid, setisMailFormValid] = useState(false);

  const handleMailChange = (e) => {
    setemailToSend(e.target.value);

    if (!emailToSend.trim().length) {
      setemailError("Please Enter email!");
    }
    if (emailToSend.trim().length) {
      setemailError(!isEmailValid(emailToSend) ? "Email is invalid!" : "");
      setisMailFormValid(isEmailValid(emailToSend));
    }
  };

  const handleEnterPress = (event) => {
    if (event.key === "Enter") {
      ticketDataPdf(event, emailToSend);
    }
  };

  return (
    <React.Fragment>
      <Modal
        id="ticketdetails"
        lg={"medium"}
        show={true}
        // onHide={closeModal}
        dialogClassName="modal-90w"
        fullscreen={"sm-down"}
        className="modalData"
      >
        <Modal.Header id="import" className="d-flex justify-content-between bg-white align-items-center">
          <h5 className="m-0 font-weight-bold">
            <Modal.Title className="m-0">
              <Translation>{(t) => <>{t("Send Mail as PDF")}</>}</Translation>
            </Modal.Title>
          </h5>
          <Translation>
            {(t) => (
              <Button id="modal" title={t("Close")} type="button" onClick={closeModal} className="close-btn py-0" data-dismiss="modal">
                <i className="nc-icon nc-simple-remove text-danger" />
              </Button>
            )}
          </Translation>
        </Modal.Header>
        <Modal.Body className="pt-0">
          <Form>
            <label>
              <Translation>{(t) => <>{t("Email Address")}</>}</Translation>
              <span className="asterisk">*</span>
            </label>
            <Form.Control
              placeholder="example@gmail.com"
              type="text"
              name="email"
              value={emailToSend}
              onChange={handleMailChange}
              onKeyDown={handleEnterPress}
              autoComplete="off"
              required
            />
          </Form>
          <span className="help-block">{emailError}</span>
        </Modal.Body>
        <Modal.Footer className="pt-0">
          <Button disabled={!isMailFormValid} onClick={(e) => ticketDataPdf(e, emailToSend)}>
            <Translation>{(t) => <>{t("Send Mail")}</>}</Translation>
          </Button>
          <Button onClick={closeModal}>
            <Translation>{(t) => <>{t("Cancel")}</>}</Translation>
          </Button>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
};

export default SendInvoiceModal;
